import * as React from 'react';

function Confirm(props) {
	return (
		<svg
			aria-label={`confirm icon`}
			width={'34'}
			height={'34'}
			viewBox={'0 0 34 34'}
			fill={'none'}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			<title>confirm icon</title>
			<circle cx={'17'} cy={'16.75'} r={'15.9'} stroke={'#1F1F1F'} strokeWidth={'1.2'} />
			<path d={'M15.8037 22.3433C15.7956 22.0503 15.7915 21.8306 15.7915 21.6841C15.7915 20.8215 15.9136 20.0768 16.1577 19.4502C16.3368 18.9782 16.6257 18.5021 17.0244 18.022C17.3174 17.672 17.8423 17.1634 18.5991 16.4961C19.3641 15.8206 19.8605 15.2835 20.0884 14.8848C20.3162 14.486 20.4302 14.0506 20.4302 13.5786C20.4302 12.7241 20.0965 11.9754 19.4292 11.3325C18.7619 10.6815 17.944 10.356 16.9756 10.356C16.0397 10.356 15.2585 10.6489 14.6318 11.2349C14.0052 11.8208 13.5942 12.7363 13.3989 13.9814L11.1406 13.7129C11.3441 12.0446 11.9463 10.7669 12.9473 9.87988C13.9564 8.99284 15.2869 8.54932 16.939 8.54932C18.6886 8.54932 20.0843 9.02539 21.126 9.97754C22.1676 10.9297 22.6885 12.0812 22.6885 13.4321C22.6885 14.2134 22.5054 14.9336 22.1392 15.5928C21.7729 16.252 21.0568 17.0535 19.9907 17.9976C19.2746 18.6323 18.8066 19.1003 18.5869 19.4014C18.3672 19.7025 18.2044 20.0483 18.0986 20.439C17.9928 20.8296 17.9318 21.4644 17.9155 22.3433H15.8037ZM15.6694 26.75V24.2476H18.1719V26.75H15.6694Z'} fill={'#1F1F1F'} />
		</svg>
	);
}

export default Confirm;
